import { Component } from '@angular/core';
import { DesignService } from '../../core/services/design.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent {
  constructor(private designService: DesignService) {
    this.designService.setHeaderStyle('privacyAndPolicy');
  }
}
